function initPastaelCommunityHighlightReveal(root = document) {
  const sections = root.querySelectorAll('.pastael-community:not(.is-in-view)');

  sections.forEach((section) => {
    const mark = section.querySelector('.pastael-community__highlight-mark');
    if (!mark) return;

    const reveal = () => {
      section.classList.add('is-in-view');
      mark.classList.add('is-visible');
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      reveal();
      return;
    }

    if (section.dataset.highlightRevealObserved === 'true') return;
    section.dataset.highlightRevealObserved = 'true';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12,
      }
    );

    observer.observe(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPastaelCommunityHighlightReveal());
} else {
  initPastaelCommunityHighlightReveal();
}

document.addEventListener('shopify:section:load', (event) => {
  initPastaelCommunityHighlightReveal(event.target);
});
